import React from "react"
import TEintrachtKader from "../technical/t-eintracht-kader"

const OProfisLineupBlock = () => {
  return <TEintrachtKader />
}

export default OProfisLineupBlock
